module.exports = __webpack_public_path__ + "assets/icon-checkbox-checked.e36e1b18.svg";